"use client";

import React, { useEffect, useState } from "react";

const EYE_REPLAY_INTERVAL_MS = 5 * 60 * 1000;

const pupilTransformStyle: React.CSSProperties = {
  transformBox: "fill-box",
  transformOrigin: "center",
};

export function VisiaLogo({ size = 32 }: { size?: number }) {
  const h = Math.round(size * 1.2);
  // `playToken` is bumped every few minutes; keying the animated groups on it
  // remounts them so the CSS animation (iteration-count: 1) replays. It starts
  // at 0 (no animation) so the logo sits still on load instead of playing every
  // mount; the eye only comes alive on the interval.
  const [playToken, setPlayToken] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setPlayToken((t) => t + 1),
      EYE_REPLAY_INTERVAL_MS,
    );
    return () => clearInterval(id);
  }, []);

  const isPlaying = playToken > 0;
  const lookClass = isPlaying
    ? "motion-safe:animate-visia-eye-look"
    : undefined;
  const blinkClass = isPlaying
    ? "motion-safe:animate-visia-eye-blink"
    : undefined;

  return (
    <svg width={size} height={h} viewBox="0 0 207 250" fill="none">
      <path
        fill="#299D8F"
        d="M137.9 164.667L205.9 125.384L56.766 39.414V0L206.66 86.402V164.292L137.9 204.024V164.667Z"
      />
      <path
        fill="#299D8F"
        d="M68.758 85.333L0.759 124.616L149.89 210.586V250L0 163.598V85.708L68.758 45.976V85.333Z"
      />
      <g
        key={`look-${playToken}`}
        className={lookClass}
        style={pupilTransformStyle}
      >
        <g
          key={`blink-${playToken}`}
          className={blinkClass}
          style={pupilTransformStyle}
        >
          <path
            fill="currentColor"
            d="M103.14 162.341C124.2 162.341 141.28 145.257 141.28 124.184C141.28 103.11 124.2 86.027 103.14 86.027C82.07 86.027 64.997 103.11 64.997 124.184C64.997 145.257 82.07 162.341 103.14 162.341Z"
          />
          <circle fill="currentColor" cx="103" cy="124" r="38" />
        </g>
      </g>
    </svg>
  );
}

export function VisiaLogoMark() {
  return (
    <svg width="48" height="56" viewBox="0 0 207 250" fill="none">
      <path
        fill="currentColor"
        opacity="0.3"
        d="M137.9 164.667L205.9 125.384L56.766 39.414V0L206.66 86.402V164.292L137.9 204.024V164.667Z"
      />
      <path
        fill="currentColor"
        opacity="0.3"
        d="M68.758 85.333L0.759 124.616L149.89 210.586V250L0 163.598V85.708L68.758 45.976V85.333Z"
      />
      <circle fill="currentColor" opacity="0.2" cx="103" cy="124" r="38" />
    </svg>
  );
}
